import BasicRepository from "./basicRepository";
import Client from "../client";

class AlertRepository extends BasicRepository<any> {
    constructor(client: Client) {
        super("Alerts", client);
    }
    getDetails(task: any, options: any) {
        return this.client.get(task.Links["Details"], options);
    }
    getQueuedBehind(task: any, options: any) {
        return this.client.get(task.Links["QueuedBehind"], options);
    }
    getRaw(task: any) {
        return this.client.getRaw(task.Links["Raw"]);
    }
    filter(options: any) {
        return this.client.get(this.client.getRootDocument().Links["Tasks"], options);
    }
    rerun(task: any) {
        return this.client.post(task.Links["Rerun"]);
    }
    cancel(task: any) {
        return this.client.post(task.Links["Cancel"]);
    }
    changeState(task: any, state: any, reason: any) {
        return this.client.post(task.Links["State"], {state, reason});
    }
}

export default AlertRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/alertRepository.ts